import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibCheckbox',
  props: {
    color: {
      type: String,
      default: ''
    },
    disable: {
      type: Boolean,
      default: false
    },
    falseValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    left: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    trueValue: {
      type: Boolean,
      default: undefined
    },
    val: {
      type: [Boolean, Number, String],
      default: false
    },
    value: {
      type: [Boolean, Number, String, Array],
      default: false
    }
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    themeStyle: function themeStyle() {
      return {
        color: this.color || this.theme.primaryColor
      };
    }
  },
  methods: {
    handleChange: function handleChange(value) {
      this.$emit('input', value, this.val);
    },
    validate: function validate() {
      this.$emit(this.value ? 'validationFailed' : 'validationSuccessful');
      return this.value;
    }
  }
};